<template>
    <div>
        <headerNotice routerName="商品标签"></headerNotice>
        <!-- 标签列表 -->
        <div class="tagList">
            <div class="header">
                <el-button type="primary" @click="addDialog">
                    <i class="el-icon-plus"></i> 新增
                </el-button>
                <h3>标签可用于订货时快速筛选，标签数量不限，每个商品最多可添加三个标签</h3>
            </div>
            <div class="tagBox" v-loading="loading">
                <!-- 单位列表 -->
                <div class="unitBox">
                    <el-table class="tableBox" :data="items" style="width:100%" fit v-loading="loading">
                        <el-table-column align="center" label="标签名称">
                            <template slot-scope="scope">
                                <el-tag
                                    size="medium"
                                    :color="scope.row.color"
                                    style="color:#fff;"
                                >{{scope.row.labelName}}</el-tag>
                            </template>
                        </el-table-column>
                        <el-table-column align="center" prop="sort" label="排序"></el-table-column>
                        <el-table-column align="center" label="操作">
                            <template slot-scope="scope">
                                <el-button
                                    v-show='scope.row.labelName != "推荐"'
                                    size="small"
                                    type="warning"
                                    @click="editBtn(scope.row)"
                                >修改</el-button>
                                <el-button
                                    v-show='scope.row.labelName != "推荐"'
                                    size="small"
                                    type="danger"
                                    @click="deleteBtn(scope.row)"
                                >删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>

        <!-- dialog弹框 -->
        <el-dialog class="dialogBox" :title="dialogTitle" :visible.sync="showDialog" width="30%">
            <div class="tagName">
                <el-row>
                    <el-col :span="15">
                        <el-form label-width="120px">
                            <el-form-item label="标签名字" :rules="[{'required':true}]">
                                <el-input
                                    placeholder="请输入标签名字，≤6个字"
                                    :maxlength="6"
                                    v-model="formData.labelName"
                                    size="small"
                                ></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
                <el-row v-if="isModifing">
                    <el-col :span="15">
                        <el-form label-width="120px">
                            <el-form-item label="排序" :rules="[{'required':true}]">
                                <el-input
                                    placeholder="请输入排序数字"
                                    type="number"
                                    :maxlength="3"
                                    v-model="formData.sort"
                                    size="small"
                                ></el-input>
                            </el-form-item>
                        </el-form>
                    </el-col>
                </el-row>
            </div>
            <div class="radioColor">
                <el-form label-width="120px">
                    <el-form-item label="选择颜色" :rules="[{'required':true}]">
                        <el-radio-group v-model="formData.color">
                            <el-radio label="#FF9F13" class="test">{{formData.labelName}}</el-radio>
                            <el-radio label="#FF6350">{{formData.labelName}}</el-radio>
                            <el-radio label="#F13131">{{formData.labelName}}</el-radio>
                            <el-radio label="#7ED321">{{formData.labelName}}</el-radio>
                            <el-radio label="#20ADE5">{{formData.labelName}}</el-radio>
                            <el-radio label="#33CCCC">{{formData.labelName}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                </el-form>
            </div>
            <div class="confirmBtn">
                <el-button type="primary" @click="confirmData">确定</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            loading: true,
            items: [],
            dialogTitle: '新增商品标签',
            showDialog: false,
            formData: {
                labelName: '',
                color: '',
            },
            isModifing: false,
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        this.getDatas()
    },
    methods: {
        //获取列表数据
        getDatas(params) {
            let self = this;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/LabelService/GetLabel",
                params: params,
                success(res) {
                    self.items = res;
                    self.loading = false;
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        // 新增标签
        addDialog() {
            this.dialogTitle = '新增商品标签';
            this.isModifing = false;
            this.formData = {
                labelName: '',
                color: '',
            }
            this.showDialog = true;
        },
        //确认
        confirmData() {
            let self = this;
            if (!this.formData.labelName || !this.formData.color) {
                this.$message.error('请填写标签名和选择颜色！');
                return;
            }
            //修改标签
            if (this.isModifing) {
                if(!/^(([0-9]*[1-9][0-9]*)|(0))$/.test(this.formData.sort)) {
                    this.$message.error('请填写正确的排序数字！');
                    return
                }
                $http.PUT({
                    url: this.$store.state.apiUrl + "/api/services/app/LabelService/UpdateLabel",
                    data: this.formData,
                    success(res) {
                        self.$message({
                            message: '修改成功',
                            type: 'success'
                        });
                        self.getDatas();
                        self.showDialog = false;
                    },
                    fail(res) {

                    }
                })
            } else {//新增标签
                $http.POST({
                    url: this.$store.state.apiUrl + "/api/services/app/LabelService/CreateLabel",
                    data: this.formData,
                    success(res) {
                        self.$message({
                            message: '添加成功',
                            type: 'success'
                        });
                        self.getDatas();
                        self.showDialog = false;
                    },
                    fail(res) {

                    }
                })
            }
        },
        //修改标签
        editBtn(row) {
            this.formData = row;
            this.dialogTitle = '修改商品标签';
            this.isModifing = true;
            this.showDialog = true;

            console.log(this.formData);
        },
        //删除标签
        deleteBtn(row) {
            let self = this;
            this.$confirm('此操作将永久删除该条数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                $http.DELETE({
                    url: this.$store.state.apiUrl + "/api/services/app/LabelService/DeleteLabel",
                    params: {
                        Id: row.labelID,
                    },
                    success(res) {
                        self.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                        self.getDatas();
                    },
                    fail(res) {

                    }
                })
            }).catch(() => {

            });
        },
    }
}
</script>

<style lang='scss' scoped>
// 标签列表
.tagList {
    padding: 20px;
    .header {
        background: #f3f3f3;
        margin: 0 100px;
        padding: 20px 30px;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .tableBox {
        border: 1px solid #c5c5c5;
    }
    .tagBox {
        margin: 0 100px;
        padding: 20px 30px;
        ul {
            li {
                height: 80px;
                display: flex;
                align-items: center;
                justify-content: space-between;
                border-bottom: 1px solid #eee;
                .left {
                    background-color: coral;
                    border-radius: 4px;
                    padding: 4px 6px;
                    font-size: 12px;
                    color: #fff;
                }
            }
        }
    }
}
//dialogBox弹框
.dialogBox {
    .radioColor {
        display: flex;
        align-items: top;
        .el-radio-group {
            display: flex;
            flex-direction: column;
            align-items: center;
            .el-radio {
                margin: 5px 0;
                height: 30px;
                display: flex;
                align-items: center;
                justify-content: center;
                /deep/ .el-radio__label {
                    margin-left: 10px;
                    display: block;
                    padding: 0;
                    height: 30px;
                    width: 100px;
                    line-height: 30px;
                    text-align: center;
                    background: #ff9f13;
                    color: #fff;
                    font-size: 12px;
                    border-radius: 4px;
                }
                &:nth-of-type(1) {
                    /deep/ .el-radio__label {
                        background: #ff9f13;
                    }
                }
                &:nth-of-type(2) {
                    /deep/ .el-radio__label {
                        background: #ff6350;
                    }
                }
                &:nth-of-type(3) {
                    /deep/ .el-radio__label {
                        background: #f13131;
                    }
                }
                &:nth-of-type(4) {
                    /deep/ .el-radio__label {
                        background: #7ed321;
                    }
                }
                &:nth-of-type(5) {
                    /deep/ .el-radio__label {
                        background: #20ade5;
                    }
                }
                &:nth-of-type(6) {
                    /deep/ .el-radio__label {
                        background: #33cccc;
                    }
                }
            }
        }
    }
    .confirmBtn {
        margin-top: 20px;
        display: flex;
        justify-content: center;
    }
}
</style>